import { ButtonV2, Dialog } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../../../components/toast/Toast';
import { useRemoveFYIEntityMapping } from '../../../../../queries/use-remove-fyi-entity-map';
import { Entity } from '../../../../../types/entity';

type FYIDisconnectProps = {
    entity: Entity;
};

function FYIDisconnect({ entity }: FYIDisconnectProps): JSX.Element {
    const fyiName = entity.integrations.fyi?.name ?? '';
    const [confirmDisconnect, setConfirmDisconnect] = useState(false);
    const disconnectQuery = useRemoveFYIEntityMapping(entity.id);

    function disconnect(): void {
        disconnectQuery.mutate(entity.id, {
            onSettled: () => {
                setConfirmDisconnect(false);
            },
            onError: (res) => {
                toastNotification('error', res?.response?.data?.message ?? 'Something went wrong. Please try again.');
            },
            onSuccess: () => {
                toastNotification('success', `Successfully disconnected ${entity.name} from ${fyiName}.`);
            },
        });
    }

    return (
        <>
            <Dialog
                title={`Disconnect ${fyiName}`}
                description={`Do you want to remove the link between ${entity.name} and ${fyiName}? This action may affect the progress of associated workpapers.`}
                type="error"
                isOpen={confirmDisconnect}
                onClose={(): void => {
                    setConfirmDisconnect(false);
                }}
                primaryAction="Disconnect"
                onPrimaryActionClick={disconnect}
                secondaryAction="Cancel"
                onSecondaryActionClick={(): void => {
                    setConfirmDisconnect(false);
                }}
                isLoading={disconnectQuery.isLoading}
            />
            <div>
                <p className="text-sm text-gray-800 font-medium mb-1">Disconnect</p>
                <label className="text-sm text-gray-600 max-w-[80ch] block mb-2">
                    Remove the link between this entity and the FYI client. Any workpapers linked to an FYI job for the client will have the
                    link removed. All associated documents will be permanently deleted, and the statuses of any related worksheets will be
                    recalculated.
                </label>
                <ButtonV2 type="danger" label="Disconnect" size="sm" onClick={(): void => setConfirmDisconnect(true)} />
            </div>
        </>
    );
}

export default FYIDisconnect;
